/* eslint-disable no-unused-vars */
import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react'
import itemTypeList from '../../common/itemTypeList';
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';
import { Toast } from '../../common/message';
import UserPointExp from '../../common/UserPointExp';

const Order_order = () => {

    // 시간 불러오는 부분
    let toDate = new dayjs().format('YYYY-MM-DD');
    let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')
  
    const minusDate = (number)=>{
      const now = new dayjs().subtract(number, 'days');
      return now.format('YYYY-MM-DD');
    }
  
    const plusDate = (number)=>{
      const now = new dayjs().add(number, 'days');
      return now.format('YYYY-MM-DD');
    }
  
    const toDay = {
      date: toDate,
      time: toTime,
      minusDate,
      plusDate
    }
    
  const [books, setBooks] = useState([]);
  const columns = [
    'No', '브랜드', '분류', '제품이름', '탄방', '둔산', '자양', '충대'
  ];

  const firstCursor = useRef(null);
  
  const [itemIno, setItemIno] = useState(0);
  const [itemBrand, setItemBrand] = useState('');
  const [itemType, setItemType] = useState('');
  const [itemName, setItemName] = useState('');
  const [itemPrice, setItemPrice] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [orderMemo, setOrderMemo] = useState('');
  const [countTB, setCountTB] = useState(0);
  const [countDS, setCountDS] = useState(0);
  const [countJY, setCountJY] = useState(0);
  const [countCD, setCountCD] = useState(0);

  const [orderCallState, setOrderCallState] = useState(0);

  const [searchText, setSearchText] = useState('');

  // 수량 업 다운
  const ItemCount_Down5 = ()=>{
    if(itemCount <= 0 || itemCount < 5) return;
    setItemCount(itemCount - 5);
  }
  const ItemCount_Down = ()=>{
    if(itemCount <= 0) return;
    setItemCount(itemCount - 1);
  }
  const ItemCount_Up = ()=>{
    setItemCount(itemCount + 1);
  }
  const ItemCount_Up5 = ()=>{
    setItemCount(itemCount + 5);
  }

  // 아이템 타입
  const searchItemTypeSelect = async (e)=>{
    setItemType(e.target.value);

    if(searchText){
      itemTypeNameSearch(e.target.value);
    } else {
      itemTypeSearch(e.target.value);
    }
  };

  // 검색 버튼 클릭시
  const btnSearch = async (e)=>{
    e.preventDefault();

    if(!searchText) return alert('검색어를 입력해주세요');

    if(searchText&& itemType === '전체') {
      return itemNameSearch(); // 제품명만 조회
    }

    if(searchText&& itemType !== '전체'){
      return itemTypeNameSearch(); // 분류와 제품명 동시 조회
    } 

    if(!searchText&& itemType === '전체') {
      return itemTypeSearch(itemType); // 분류만 조회
    } 
    
  };

  // 분류 + 제품명 검색
  const itemTypeNameSearch = async (value)=>{
  await Axios.get('/api/sale/sale_typename', {
    params: { searchText: searchText, Type: value ?? itemType }
  })
  .then((res)=>{
    if(res.data.length)
    {
      setBooks(res.data);
    } else {
      setBooks([]);
    }
    });
  };

  // 제품 타입 검색
  const itemTypeSearch = async (value)=>{
    await Axios.get(`/api/order_order/orderlist`, {
      params: { type: value }
    })
    .then(res=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  // 제품명 검색
  const itemNameSearch = async ()=>{
    await Axios.get(`/api/order_order/orderlist_search`, {
      params: { searchText }
    })
    .then(res=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  }

  // 주문 요청 함수
  const orderItemAdd = async ()=>{
    await Axios.post(`/api/order_order/order/`, {
      itemIno: itemIno, step: '확인중', itemBrand: itemBrand, itemType: itemType, itemName: itemName,
      itemPrice: itemPrice, countTB: countTB, countDS: countDS, countJY: countJY, countCD: countCD,
      itemCount: itemCount, orderMemo: orderMemo, userId: window.sessionStorage.getItem('basicID'),
      date: toDay.time, store: window.sessionStorage.getItem('basicStore'), OrderCallState: orderCallState
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${itemName} 주문 요청 성공` });
    })
    .catch((err)=>{
      console.log('주문 요청 오류 발생: ', err);
    });
  }

  // 해당 아이템이 이미 주문요청이 되었을때
  const orderItemUpdate = async (state)=>{
    // 중요도가 기존 신청한거 보다 높은 수준일 경우 하위로 변경 못하게
    let ordercallstate = 1;
    if(state < orderCallState){
      ordercallstate = orderCallState;
    } else if(state > orderCallState){
      ordercallstate = state;
    }
    await Axios.put(`/api/order_order/orderitem_update`, {
      itemIno: itemIno, itemCount: itemCount, orderMemo: orderMemo,
      userId: window.sessionStorage.getItem('basicID'), date: toDay.time,
      store: window.sessionStorage.getItem('basicStore'), OrderCallState: ordercallstate
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${itemName} 주문 요청 성공` });
    })
    .catch((err)=>{
      console.log('중복 주문 요청 오류 발생: ', err);
    })
  }

  // 주문요청 버튼
  const btnOrderClick = async ()=>{
    
    //if(!itemIno) return alert(`${itemName}은 주문요청 할 수 없습니다, 관리자에게 문의해 주세요`);
    if(!itemName) return alert('제품을 선택해 주세요');
    if(!itemCount) return alert('주문 요청할 수량을 확인해 주세요');
    if(!orderCallState) return alert('주문 요청 중요도를 선택해주세요');
    // if(orderCallState === 3){
    //   if(!window.confirm('📢 정말 긴급한 주문이 필요한 품목입니까?')) return;
    // }
    if(orderCallState === 3 && !orderMemo) return alert('`긴급`으로 주문요청시 참고사항 입력은 필수 입니다.');
    
    // 마지막으로 한번 더 확인
    if(!itemIno && !itemName) return alert('주문 요청하는 제품의 정보가 제대로 넘어오지 않았습니다, 다시 시도해 주세요.');

    if(!window.confirm('주문요청을 하시겠습니까?')) return;

    // 주문요청 전 해당 item ID 값이 있는지 확인
    await Axios.get(`/api/order_order/orderitem_check`, {
      params: { itemIno: itemIno, itemName: itemName }
    })
    .then((res)=>{      
      if(res.data.value){ // 이미 요청목록에 제품이 있을때       
        // 이미 등록된 중요도의 값을 넘기기
        orderItemUpdate(res.data.state); // 해당 주문건 수정
      } else { // 요청 목록에 제품이 없을때
        orderItemAdd(); // 주문요청 실행 함수
      }

      if(orderCallState === 3){
        // 포인트 및 기여도 차감
        UserPointExp('주문관리', `${itemName} 긴급 주문요청`, 1, 1, '차감');
      } else {
        // 포인트 및 기여도 지급
        UserPointExp('주문관리', `${itemName} 주문요청`, 1, 1);
      }

      setOrderCallState(''); // 중요도 값 초기화
      reset();
      
    });
  }

  // 리셋 함수
  const reset = ()=>{
    setSearchText('');
    setItemType('전체');
    setItemName('');
    setItemCount(0);
    setOrderCallState(0);
    setOrderMemo('');

    setSelectedRow(-1);
  }

  useEffect(()=>{
    document.title = '주문 요청';

    firstCursor.current.focus();
  }, [])

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  const navigate = useNavigate();
  
  return (
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    <div className='flex justify-between items-center'>
      <ul className='flex gap-3'>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={()=>navigate('/order/order')}>주문요청</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/list')}>요청목록</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/state')}>처리완료</li>
      </ul>
      {/* <div>
        <button className='px-5 py-3 text-yellow-400'>새로고침</button>
      </div> */}
    </div>

    <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>

      {/* 메인 */}
      <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
        <table id='testTable' className='w-full'>
          <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
            <tr className='border-b-[1px] border-gray-500'>
              {columns.map((column) => (
                <th className='p-3' key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className='text-center'>
            {
              books.length
              ?
              books.map((book, idx) => (
                <tr className=
                {`
                  duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                  ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                `}
                key={idx} onClick={(e)=>{
                  setSelectedRow(idx);
                  setItemIno(book.no);
                  setItemBrand(book.i_brand);
                  setItemType(book.i_type);
                  setItemName(book.i_name);
                  setItemPrice(book.i_price);
                  setCountTB(book.i_count_TB);
                  setCountDS(book.i_count_DS);
                  setCountJY(book.i_count_JY);
                  setCountCD(book.i_count_CD);

                  window.sessionStorage.setItem('select_copy', book.i_name);
                }}>
                  <td className='p-2.5'>{idx + 1}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_brand}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_type}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_name}</td>
                  <td className={`p-2.5 ${book.i_count_TB < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_TB === 0 ? '-' : book.i_count_TB}</td>
                  <td className={`p-2.5 ${book.i_count_DS < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_DS === 0 ? '-' : book.i_count_DS}</td>
                  <td className={`p-2.5 ${book.i_count_JY < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_JY === 0 ? '-' : book.i_count_JY}</td>
                  <td className={`p-2.5 ${book.i_count_CD < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_CD === 0 ? '-' : book.i_count_CD}</td>
                </tr>
              ))
              :
              <tr className='relative'>
                <td className='absolute w-full top-[30vh] left-auto'>
                  <NotData/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      {/* 사이드 */}
      <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
        <div className='bg-[#0067BD] py-2 text-center'>
          <p className='text-left pl-3'>
            ※ 제품 주문 요청
          </p>
        </div>

        <div className='p-3 flex flex-col gap-2'>

          {/* 분류 및 검색 버튼 */}
          <form className='flex items-center gap-2' autoComplete='off'>
            <div className='w-full'>                
              <input ref={firstCursor} id='searchInput' className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='브랜드 or 이름' value={searchText} onChange={(e)=>setSearchText(e.target.value)} onDoubleClick={()=>setSearchText(window.sessionStorage.getItem('select_copy'))}/>
            </div>  
            <input className='bg-blue-600 px-3 py-2 h-12 rounded-sm w-[30%] cursor-pointer' type='submit' value='검색' onClick={btnSearch}/>
          </form>
          
          <select id='storeInput' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' 
          value={itemType} onChange={searchItemTypeSelect} >
            {itemTypeList.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}          
          </select>

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>

          {/* 제품 이름 및 수량 */}
          <div className='w-full'>
            <p>제품 이름</p>
            <input className='bg-[#2E2E2E] mt-2 rounded-t-md w-full h-[70px] text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400' placeholder='〈 제품을 선택하세요 〉' disabled type='text' value={itemName}/>
          </div>

          {/* 주문 요청 수량 */}
          <div className='flex flex-col justify-center gap-2'>
            <p className='whitespace-nowrap'>요청 수량</p>
            <div className='flex justify-center items-center gap-1 w-full'>
              <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
              onClick={ItemCount_Down5}>
                {'《'}
              </button>
              <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
              onClick={ItemCount_Down}>
                {'〈'}
              </button>
              <div className='bg-[#2E2E2E] py-2.5 rounded-md'>
                <p className='whitespace-nowrap w-20 text-center' id='item_count'>
                  {`${itemCount} 개`}
                </p>
              </div>              
              <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
              onClick={ItemCount_Up}>
                {'〉'}
              </button>
              <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
              onClick={ItemCount_Up5}>
                {'》'}
              </button>
            </div>
          </div>

          {/* 주문 요청 중요도 */}
          <div className='w-full bg-[#2E2E2E] p-2 rounded-md'>
            <p>주문 요청 중요도</p>
            <div className='flex justify-center mt-2 items-center'>
              <ul className="grid w-full gap-1 grid-cols-3">
                <li>
                  <input type="checkbox" id="card" className="hidden peer" checked={orderCallState === 1 ? true : false} onChange={(e)=>{
                    setOrderCallState(1);
                  }} />
                  <label htmlFor="card" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">                           
                    <div className="flex justify-center items-center">
                      <div className="w-full whitespace-nowrap text-base">보통</div>
                    </div>
                  </label>
                </li>
                <li>
                  <input type="checkbox" id="cash" className="hidden peer" checked={orderCallState === 2 ? true : false} onChange={(e)=>{
                    setOrderCallState(2);
                    }} />
                  <label htmlFor="cash" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                    <div className="flex justify-center items-center">
                      <div className="w-full whitespace-nowrap text-base">중요</div>
                    </div>
                  </label>
                </li>
                <li>
                  <input type="checkbox" id="transfer" className="hidden peer" checked={orderCallState === 3 ? true : false} onChange={(e)=>{
                    setOrderCallState(3);
                    }} />
                  <label htmlFor="transfer" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                    <div className="flex justify-center items-center">
                      <div className="w-full whitespace-nowrap text-base">긴급</div>
                    </div>
                  </label>
                </li>
              </ul>
            </div>
          </div>

          {/* 중요도 안림말 */}
          <div className='bg-[#2E2E2E] p-3 rounded-md whitespace-normal'>
            <div className='flex gap-2'>
              <p>📢</p>
              <p>`긴급`은 급하게 꼭 필요한 품목이 아니면 지양해 주시길 바랍니다.</p>
            </div>

            {/* 언더라인 */}
            <div className='border-b-[1px] border-gray-500 py-1'></div>

            <p className='text-yellow-400 text-center mt-3 mb-1'>처리 상황에 따라 시간이 걸릴 수 있습니다.</p>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <div className='flex justify-between'>
              <p className=''>참고사항</p>
              <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
                펼치기
              </button>
            </div>
            <div className='flex flex-col justify-center items-center'>
              <textarea className='h-20 bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 w-full p-2 rounded-md outline-none border-[1px] border-gray-400'
              type='text' value={orderMemo} placeholder='참고할 내용은 무엇인가요?' onChange={(e)=>{
                setOrderMemo(e.target.value);
              }} />
            </div>
            </div>

          {/* 주문 요청 */}
          <div className='flex flex-col gap-2 pt-2'>
            <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-sm text-center border-[1px] border-yellow-500/80 duration-150 hover:scale-[0.98] active:border-none' onClick={btnOrderClick} >
              주문 요청
            </button>
          </div>

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>

          {/* 하단 알림말 */}
          <div className='flex whitespace-normal text-xs mt-3 gap-5 bg-[#2E2E2E] rounded-md p-5'>
            <div className='min-w-[30px] h-[30px] bg-yellow-500/80 rounded-md text-center'>
              <span className='text-2xl font-bold'>!</span>
            </div>
            <div className='flex flex-col'>
              <span>※ 주문 요청시 <span className='text-green-300'>최소 2주 가량의 여분</span> <u className='text-red-400'>수량을 체크 후</u> 한번에 주문 요청해 주세요.</span>
              <span className='text-gray-400'>요청된 주문건 들은 입고되려면 대략 1~2주 가량 소요가 될 예정입니다.</span>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  )
}

export default Order_order